import {ReactReduxContext, useDispatch, useSelector} from "react-redux";
import React, {useContext} from "react";
import {setFormData} from "../../actions";

/**
 * This creates a block containing radio buttons and labels for each button with a text header
 *
 * @param headerText The text describing the buttons
 * @param radioName The parameter which will be updated in the store (name of value of all radio buttons in this group)
 * @param currentValue initial value of button, currently using a useSelector
 * @param radioValues An array of objects with the fields "id" and "text".
 *                    "id" provides an id for the radio button which is also referenced by the accompanying label.
 *                    "text" is the text contained in the label.
 * @returns {Element}
 * @constructor
 */
export function Step3Radio({headerText, radioName, radioValues, fieldName}) {

    const dispatch = useDispatch();
    const iter = Array.from(radioValues);
    const context = useContext(ReactReduxContext);
    const error = () => context.store.getState().app.errors.step3;
    const errorMap = useSelector(error);

    let finalClass = '';

    if (radioName in errorMap) {
        finalClass = 'error';
    }

    const source = () => context.store.getState().app.stepData.step3[fieldName];
    const valMap = useSelector(source);

    return (
        <div className="step3Input">
            <div className="radios">
                <fieldset>
                    <legend className={finalClass}>{headerText}</legend>
                    <div>
                        {
                            iter.map((data, index) => {
                                return (
                                    <div className="radio-wrapper" key={data.id}>
                                        <input
                                            checked={valMap === index + 1}
                                            key={index}
                                            type="radio"
                                            aria-required="true"
                                            id={data.id}
                                            name={radioName}
                                            value={index + 1}
                                            onChange={(e) => {
                                                let v = {};
                                                v[radioName] = parseInt(e.target.value);
                                                dispatch(setFormData(3, v));
                                            }}
                                        />
                                        <label htmlFor={data.id}>{data.text}</label>
                                    </div>
                                );
                            })
                        }
                    </div>
                </fieldset>
            </div>
        </div>
    );
}